import {
  $post, $get, $JsonPost, vte,
} from '@/utils/axios-request';


class Word {
  // 查看词汇
  public async getStudyList(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/getStudyList`, postData);
  }

  // 新的查看词汇
  public async selectUserWordListPage(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/selectUserWordListPage`, postData);
  }

  // 查看单元
  public async getWordALLUnit(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/getWordALLUnit`, postData);
  }

  // 加入/移除生词本
  public async addOrRemoveTroubleWord(postData: any): Promise<any> {
    return await $JsonPost(`${vte}/troubleWord/api/v1/addOrRemoveTroubleWord`, postData);
  }
}
export default new Word();
